import clsx from 'clsx'
import { ButtonHTMLAttributes, FC } from 'react'
import { SpinnerIcon } from 'components/svg'

interface Props {
  isLoading: boolean
}

const Button: FC<Props & ButtonHTMLAttributes<HTMLButtonElement>> = ({
  isLoading = false,
  className,
  children,
  disabled,
  ...rest
}) => (
  <button
    type="submit"
    aria-label="submit"
    disabled={isLoading || disabled}
    className={clsx(
      'px-4 h-10 text-sm rounded shadow-md focus:outline-none',
      disabled
        ? 'text-gray-100 bg-gray-300'
        : 'text-white bg-indigo-500 hover:bg-green-500',
      className
    )}
    {...rest}
  >
    {isLoading ? <SpinnerIcon /> : children}
  </button>
)

export default Button
